export default "__VITE_ASSET__DVc6TkO7__"